/**
 * Who runs the platform, as named in the terms, privacy policy and data processing agreement.
 * Anything still in [brackets] shows the documents as incomplete until it's filled in.
 */
export const OPERATOR = {
  /** Legal name, e.g. "Bromputers Ltd" or "Jane Smith trading as Bromputers". */
  name: "[Legal name of the business]",
  /** e.g. "a company registered in England and Wales (number 01234567)" or "a sole trader". */
  description: "[company registration details]",
  address: "[Registered or trading address]",
  /** For privacy questions, data requests and legal notices. */
  email: "[contact email address]",
  /** The ICO data protection fee registration number, e.g. "ZB123456". */
  icoNumber: "[ICO registration number]",
} as const;

export const OPERATOR_COMPLETE = !Object.values(OPERATOR).some((v) => v.startsWith("["));

/** When this version of the documents took effect (shown on each page). */
export const LEGAL_EFFECTIVE = "12 October 2026";
